export const isMobile: boolean = window.matchMedia(
  '(pointer: coarse) and (hover: none)'
).matches;
